import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/embed/jadwal-imsak/$kota")({
  component: () => <Outlet />,
});